import {
	OverviewScreen,
	OverviewSkeleton,
} from "@commerce/insights/OverviewScreen";
import { config } from "@repo/config";
import { AsyncBoundary } from "@shared/components/AsyncBoundary";
import { orpc } from "@shared/lib/orpc";
import { dehydrateForLoader, getServerQueryClient } from "@shared/lib/server";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

const overviewSearchSchema = z.object({
	days: z.union([z.literal(7), z.literal(90)]).optional(),
});

export const Route = createFileRoute("/_saas/app/_org/$organizationSlug/")({
	validateSearch: overviewSearchSchema,
	shouldReload: false,
	loader: async ({ context, location }) => {
		const organizationId = context.organization.id;
		const { days } = overviewSearchSchema.parse(location.search);
		const queryClient = getServerQueryClient();
		await queryClient.ensureQueryData(
			orpc.insights.overview.queryOptions({
				input: { organizationId, days: days ?? 30 },
			}),
		);
		return {
			organizationId,
			dehydratedState: dehydrateForLoader(queryClient),
		};
	},
	head: () => ({ meta: [{ title: `Overview - ${config.appName}` }] }),
	component: OverviewPage,
});

function OverviewPage() {
	const { organizationId, dehydratedState } = Route.useLoaderData();
	return (
		<AsyncBoundary
			fallback={<OverviewSkeleton />}
			dehydratedState={dehydratedState}
		>
			<OverviewScreen organizationId={organizationId} />
		</AsyncBoundary>
	);
}
